import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    document.addEventListener('click', this._outsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClick)
  }

  toggle() {
    this.menuTarget.classList.toggle('hidden')
  }

  close() {
    this.menuTarget.classList.add('hidden')
  }

  select() {
    this.close()
  }
}
